var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"universalChart"},[_c('DoughnutChart',_vm._b({},'DoughnutChart',_vm.doughnutChartProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }